import api from './api';
import { useAuthStore, type AuthUser } from '../store/auth.store';

interface LoginResponse {
  access_token: string;
  refresh_token: string;
  access_expires_in_seconds: number;
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<AuthUser> {
  const resp = await api.post<LoginResponse>('/auth/login', { email, password });
  const { access_token, refresh_token, user } = resp.data;
  useAuthStore.getState().setTokens(access_token, refresh_token);
  useAuthStore.getState().setUser(user);
  return user;
}

export function logout() {
  useAuthStore.getState().logout();
}
